import React, { useState, useEffect } from 'react';
import { TableBody, TableRow, TableCell } from '@material-ui/core';
import useTable from '../useTable'
import { ActualizarPersona } from './modalActualizarPersona';
import axios from 'axios';
import { Loader, Dimmer } from 'semantic-ui-react';
import { Mensaje } from '../mensajes';
import { ActualizarOrganizacion } from './modalActualizarOrganizacion';

const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CODIGO', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'NOMBRES/RAZON SOCIAL', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'RIF', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
]

function TablaOrganizacion() {

    const [titulo1, setTitulo1] = useState();
    const [msg1, setMsg1] = useState();
    const [mostrar5, setMostrar5] = useState(false);
    const [mostrarOrganizacion, setMostrarOrganizacion] = useState(false);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [persona, setPersona] = useState();
    const [organizacion, setOrganizacion] = useState();
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [permiso, setPermiso] = useState();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    let op = require('../../../public/modulos/datos');
    let token = sessionStorage.getItem('jwtToken');

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idorganizacion.includes(target.value)
                            || x.nombre.toUpperCase().includes(target.value.toUpperCase())
                            || x.rif.toUpperCase().includes(target.value.toUpperCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    useEffect(() => {
        seleccionarRegistros();
    }, []);


    const seleccionarRegistros = () => {
        setActivate(true);
        let campos = '*';
        let nomtab = 'organizacion';
        let orden = 'idorganizacion';
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then((response) => {

            if (response.status == 200) {

                if (response.data.length > 0) {
                    setRecords(response.data);
                    setActivate(false);
                } else {
                    setRecords([]);
                }
            }

            setActivate(false);

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response === undefined ? 'Error de Conexion' : error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    };

    const seleccionarRegistro = (id) => {
        setActivate(true);
        let campos = '*';
        let nomtab = 'organizacion';
        let nomid ='idorganizacion';
        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then((response) => {

            if (response.status == 200) {  
            
                    setOrganizacion(response.data);
                    setMostrarOrganizacion(true);
            }

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response === undefined ? 'Error de Conexion' : error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(() => {

            setActivate(false);

        })
    };

    const gestionarOrganizacion = (id, ope) => (event) => {

        event.preventDefault();
        setOperacion(ope);
        if (ope === 1) {
            setMostrarOrganizacion(true);
            setDeshabilitado(false);
        } else if (ope === 2) {
            seleccionarRegistro(id);
            setDeshabilitado(true);
        }else if (ope === 3) {
            seleccionarRegistro(id);
            setDeshabilitado(true);
        }else if (ope === 4) {
            seleccionarRegistro(id);
            setDeshabilitado(true);
        }

    };

    return (
        <div className='container-fluid rounded'>
        <div className='container-fluid'>
        <div className="card">
            <Dimmer active={activate} inverted>
                <Loader inverted>cargando...</Loader>
            </Dimmer>

            <div className="container">
                <div className="content" >
                    <div className="container">
                        <div className="col-md-12 row m-0 py-2">
                            <div className="col-md-2">
                                <input type="text" className="form-control form-control-sm rounded-pill" onChange={handleSearch} placeholder="Buscar" />
                            </div>

                            <div className="col-md-1 ml-auto">
                                <button onClick={gestionarOrganizacion('', 1)}  className="btn btn-sm btn-primary rounded-circle"><i className="fas fa-plus"></i> </button>
                            </div>

                        </div>
                        <div className="col-md-12">
                            <TblContainer >
                                <TblHead />

                                <TableBody>
                                    {

                                        records && recordsAfterPagingAndSorting().map((item, index) => (
                                            <TableRow key={index} style={{ padding: "0" }}>
                                                <TableCell className='align-baseline' style={{ textAlign: "center", width: "50px" }}>{item.idorganizacion}</TableCell>
                                                <TableCell className='align-baseline' style={{ textAlign: "start", width: "250px" }}>{item.nombre}</TableCell>
                                                <TableCell className='align-baseline' style={{ textAlign: "center", width: "250px" }}>{item.rif}</TableCell>
                                                <TableCell className='align-baseline' style={{ textAlign: "center", width: "100px" }}>
                                                    <button onClick={gestionarOrganizacion(item.idorganizacion, 4)} className="btn btn-sm  btn-info rounded-circle ml-2" ><i className="fas fa-eye"></i> </button>
                                                    <button onClick={gestionarOrganizacion(item.idorganizacion, 2)} className="btn btn-sm  btn-warning rounded-circle ml-2"><i className="fa fa-edit"></i> </button>
                                                    <button onClick={gestionarOrganizacion(item.idorganizacion, 3)} className="btn btn-sm  btn-danger rounded-circle ml-2"><i className="fa fa-trash"></i> </button>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>

                            </TblContainer>
                            <TblPagination />

                        </div>
                    </div>
                </div>
            </div>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
                <ActualizarOrganizacion show={mostrarOrganizacion} operacion={operacion} organizacion={organizacion} onHideCancela={() => setMostrarOrganizacion(false)} onHideAcepta={seleccionarRegistros} />
        </div >
</div>
</div>
    );

}

export default TablaOrganizacion;


// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/tablaOrganizacion.js